
import React from "react";
import "./SailPointIdentityIQ.css";
import MenuNavbar from "../../MenuNavbar";
import Floaticons from "../../Floaticons";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IdentiyAccessManagement from "../IdentityManagement/IdentityandAccessManagement";
import InfrastructureSecurity from "../InfrastructureSecurity/InfrastructureSecurity";
import PlatformSecurity from "../PlatformSecurity/PlatformSecurity";
import CloudSecurity from "../CloudSecurity/CloudSecurity";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import { Breadcrumbs } from "@material-ui/core";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 4 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function SailPointIdentityIQ() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="banner-container">
        <img
          src="images/SecuritySchools/SailPoint/school-banner.png"
          alt="banner"
          className="banner-img"
        />
        <div className="breadcrumbs-container">
          <Breadcrumbs separator=">" color="#fff">
            <Link
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="#fff"
              href="/"
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            </Link>
            ,
            <Link
              underline="hover"
              key="2"
              color="#fff"
              href="/securityLearningFramework"
              // onClick={handleClick}
            >
              Security Learning Framework
            </Link>
            ,
            <Typography key="3" color="#fff">
              Security Schools
            </Typography>
            ,
          </Breadcrumbs>
        </div>
        <div className="banner-content">
          <h1>Security Schools</h1>
          <i>
            Lorem ipsum is a dummy text of the printing and typesetting industry
          </i>
        </div>
        <MenuNavbar />
      </div>
      <Floaticons />
      <div className="breadcrumbLinks">
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          <a className="menu_title" href="/securitySchools">
            <img src="/images/SecuritySchools/Back-button.png" />
            Security Schools and Bootcamps​
          </a>
          {value === 0 ? (
            <a className="menu_title" href="/securitySchools#I&DInitiatives">
              Identity & Access Management
            </a>
          ) : (
            ""
          )}
          {value === 1 ? (
            <a className="menu_title" href="/securitySchools#InfrastructureSecurity">
              Infrastructure Security
            </a>
          ) : (
            ""
          )}
          {value === 2 ? (
            <a className="menu_title" href="/securitySchools#platformsecurity">
              Platform Security
            </a>
          ) : (
            ""
          )}
          {value === 3 ? (
            <a className="menu_title" href="/securitySchools#cloudsecurity">
              Cloud Security
            </a>
          ) : (
            ""
          )}
          <a className="menu_title" href="">
            SailPoint IIQ
          </a>
        </Breadcrumbs>
      </div>
      <div className="main-container">
        <Box className="boxStyles">
          <Box
            sx={{ borderBottom: 0, borderColor: "divider" }}
            className="tabMenuWrap"
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab
                label="Identity & Access Management​"
                {...a11yProps(0)}
                className="tabStyles"
              />
              <Tab
                label="Infrastructure Security"
                {...a11yProps(1)}
                className="tabStyles"
              />
              <Tab
                label="Platform Security"
                {...a11yProps(2)}
                className="tabStyles"
              />
              <Tab
                label="Cloud Security"
                {...a11yProps(3)}
                className="tabStyles"
                // href='https://atci.lkm.delivery.accenture.com/ProfessionalSkills/' target='_blank'
              />
            </Tabs>
          </Box>
          <TabPanel className="tabPanelWrap" value={value} index={0}>
            {/* Section 1  */}
            <div className="about-container">
              <div className="about-wrap">
                <div className="about-row">
                  <div className="about-box box1">
                    <img
                      src="images/SailPointIQ/About.png"
                      alt="about-img"
                      className="about-img"
                    />
                  </div>
                  <div className="about-box box2">
                    <h2>About the Program</h2>
                    <p>
                      SailPoint IdentityIQ is a blended learning program
                      designed to provide an in-depth understanding of SailPoint
                      IdentityIQ, focusing on IdentityIQ architecture and its
                      key features. The course provides a conceptual
                      understanding necessary to administer, implement and
                      develop using the SailPoint IdentityIQ Identity & Access
                      Management Software.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 2  */}
            <div className="focus-container">
              <div className="focus-wrap">
                <h2>Topics in Focus</h2>
                <div className="focus-row">
                  <div className="focus-box">
                    <img src="images/SailPointIQ/corner.png" alt="corner-img" />
                    <h3>Identity Management Fundamentals</h3>
                    <p>
                      - Entity, Digital Identity, Accounts, and Identity
                      Management
                    </p>
                    <p>
                      - IDM Applications, Accounts, Permissions, Groups, Roles,
                      Common Terms
                    </p>
                    <p>
                      - IDM Access Control Models, Approvals, Notifications,
                      workflows
                    </p>
                    <p>- IDM Provisioning and de-provisioning</p>
                    <p>
                      - Access Governance and Policies, Audit, logs, Reports
                    </p>
                  </div>
                  <div className="focus-box">
                    <img src="images/SailPointIQ/corner.png" alt="corner-img" />
                    <h3>Access Management Fundamentals</h3>
                    <p>
                      - Authentication & Authorization, Directory Service
                      Overview, Multi-Factor
                    </p>
                    <p>
                      - Password Management, SAML 2.0, Oauth, OpenID Connect
                    </p>
                    <p>- SSO, Federation, Social Authentication</p>
                    <p>
                      - Session & Logout, Logging & monitoring, Alerting /
                      Integration with SIEM
                    </p>
                    <p>- REST Service Overview</p>
                  </div>
                  <div className="focus-box">
                    <img src="images/SailPointIQ/corner.png" alt="corner-img" />
                    <h3>Introduction to Identity Security with Security</h3>
                    <p>- An overview of identity security</p>
                    <p>- How SailPoint can help govern identities and access</p>
                    <p>
                      - Basic concepts related to identity access management,
                      and identity governance
                    </p>
                    <p>- SailPoint Identity Governance services</p>
                  </div>
                  <div className="focus-box">
                    <img src="images/SailPointIQ/corner.png" alt="corner-img" />
                    <h3>IdentityIQ Essentials v8.2</h3>
                    <p>
                      - Implement, administer, and support a standard IdentityIQ
                      implementation
                    </p>
                    <p>
                      - Best practices to complete application onboarding and
                      configuration, user interactions, and access requests
                    </p>
                    <p>
                      - Describe, configure, and perform ongoing IdentityIQ
                      tasks and processes, and use tools for monitoring and
                      troubleshooting the system
                    </p>
                  </div>
                  <div className="focus-box">
                    <img src="images/SailPointIQ/corner.png" alt="corner-img" />
                    <h3>
                      IdentityIQ Implementation: Rules, Scripts, and API v8.0
                    </h3>
                    <p>
                      - Demonstrate IdentityIQ for extending the product's
                      behaviors through BeanShell (Java) logic
                    </p>
                    <p>- Introduce the IdentityIQ API</p>
                    <p>- Highlight common rule and script hook points</p>
                    <p>
                      - SailPoint's recommended best practices for BeanShell
                      development
                    </p>
                  </div>
                  <div className="focus-box">
                    <img src="images/SailPointIQ/corner.png" alt="corner-img" />
                    <h3>IdentityIQ Implementation: Custom Reports</h3>
                    <p>- Customize existing report templates</p>
                    <p>- Build new report templates in IdentityIQ</p>
                    <p>
                      - Developing in XML and functional understanding of
                      IdentityIQ and the IdentityIQ objects
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 3  */}
            <div className="timeline-container">
              <div className="timeline-wrap">
                <h2>Program Timeline</h2>
                <div className="timeline-row">
                  <div className="timeline-box">
                    <img
                      src="images/SailPointIQ/Program-Timeline.png"
                      alt="Program-timeline"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Section 4 */}
            <div className="synopsis-container">
              <div className="synopsis-wrap">
                <h2>Program Synopsis</h2>
                <div className="synopsis-row">
                  <div className="synopsis-box">
                    <img
                      src="images/SailPointIQ/Program-synopsis.png"
                      alt="Program-synopsis"
                    />
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={1}>
            <InfrastructureSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={2}>
            <PlatformSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={3}>
            <CloudSecurity />
          </TabPanel>
        </Box>
      </div>
    </>
  );
}

export default SailPointIdentityIQ;

